<template>
    <div class="text-center">
        <div class="mb-20px">
            <v-icon size="50" color="secondary">mdi-check-circle</v-icon>
        </div>
        <div>
            <h2 class="tit tit--sm">회원가입이 완료되었습니다.</h2>
            <div class="font-size-16 font-weight-medium mt-10px">가입해 주셔서 감사합니다.</div>
        </div>
        <div class="mt-30px mt-md-40px">
            <v-btn x-large color="primary" to="/login">로그인 화면으로 이동</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: ["step", "value"]
}
</script>

<style scoped>
</style>